<template>
    <div id="" ref="">
        <m-search
            v-bind="{
                from: 'index_search'
            }"
        />
    </div>
</template>
<script>
import MSearch from '@/components/MSearch';
export default {
    name: "",
    data: () => ({

    }),
    mounted(){
    },
    methods: {
    },
    components: {
      MSearch
    }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Search/index.vue